/**
 * DO NOT USE. Creates a global `faire` object to hang some globals off of, for testing contexts only.
 * NodeJS Server contexts will bootstrap this manually in Zone, to avoid memory leaks.
 * @deprecated Don't use this
 */
export const initFaireGlobal = () => {
  (globalThis as any).faire = (globalThis as any).faire || {};
};
